// Remote feature flags published by the CMS to a public CDN, fetched once at startup
// to override the baked-in defaults (see @/store/featureFlags).
//
// Transport: the shared axios client for axios-retry, but with captureErrors:false —
// a public CDN blip must NOT be tagged into the per-microservice Sentry `api` error
// taxonomy (that dashboard is for our own backends). Failures degrade to defaults.
import { createHttpClient } from './http'
import { env } from '@/helpers/environment'

// Per-attempt timeout. Kept short: this fetch blocks first paint, and the store caps the
// total wait with its own deadline (see hydrate()). axios-retry retries on timeout.
const PER_ATTEMPT_TIMEOUT_MS = 2000

const client = createHttpClient({
	api: 'feature-flags',
	baseURL: env('FEATURE_FLAGS_URL', ''),
	retry: true,
	captureErrors: false,
})

/** GET the published flags JSON. Returns the parsed object, or null on any failure. */
export async function fetchFeatureFlags(): Promise<Record<string, unknown> | null> {
	try {
		const { data } = await client.get('', { timeout: PER_ATTEMPT_TIMEOUT_MS })
		return data && typeof data === 'object' ? data : null
	} catch {
		return null
	}
}
